module.exports = __webpack_public_path__ + "img/Zonnepanelen.3fb04dcd.svg";